module.exports = __webpack_public_path__ + "img/screen1.e250c40f.jpg";